export interface ILocaleInfo {
  country: string;
  country_code: string;
  time_zone: string;
  server_time: string;
  city: string;
}

// Cloudfront Origin, Behaviors 설정 필요 (SUNLOVE, WELLBEING 클라우드프론트 참고)
export const fetchLocaleInfo = async (): Promise<ILocaleInfo | undefined> => {
  // 개발 환경에서는 바로 undefined 반환
  if (import.meta.env.DEV) {
    return undefined;
  }

  try {
    const url = `${window.location.origin}/api/country`;
    const response = await fetch(url);

    if (!response.ok) {
      const message = await response.text();
      console.warn(`[LAMBDA][cloudfront_header] Failed to fetch : ${message}`);
      return undefined;
    }

    const text = await response.text();

    const data = JSON.parse(text) as ILocaleInfo;
    return data;
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    console.warn(`[LAMBDA][cloudfront_header] Failed to fetch or parse JSON: ${message}`);
    return undefined;
  }
};
